<template>
        <a
            :href="whatsappUrl"
            target="_blank"
            rel="noopener"
            class="whatsapp-chat"
            aria-label="WhatsApp"
            :style="{ '--wa-lift': lift + 'px' }"
        >
            <img src="@/assets/whatsapp.png" alt="" />
        </a>
</template>

<script>
import { whatsappBot, propertyContact } from '@/config';

/* Lo que el botón no debe tapar: barras de guardar / acciones pegadas abajo
   (Mi cuenta .bk-bar, editor y Editar varios .ee-bar, Admin → Usuarios
   .us-bar, CRM .cr-form-bar, reservar en la ficha .fx-bar, botones del
   formulario en celular .nf-nav) y el aviso de cookies. */
const OBSTACULOS = '.bk-bar, .ee-bar, .us-bar, .cr-form-bar, .fx-bar, .nf-nav, .cookie-footer';
const AIRE = 10;

export default {
    name: 'WhatsappChat',
    data() {
        return { lift: 0 };
    },
    computed: {
        whatsappUrl() {
            // El usuario property tiene su propio contacto de soporte.
            const phoneNumber = this.$store.getters.isProperty ? propertyContact.phone : whatsappBot.phone;
            const message = encodeURIComponent('Hola, necesito ayuda con...'); // Reemplaza esto con tu mensaje predeterminado
            return `https://wa.me/${phoneNumber}?text=${message}`;
        },
    },
    mounted() {
        this.programar = () => {
            if (this.raf) return;
            this.raf = requestAnimationFrame(() => { this.raf = 0; this.medir(); });
        };
        window.addEventListener('scroll', this.programar, { passive: true });
        window.addEventListener('resize', this.programar);
        // Las barras aparecen y desaparecen (elegir espacios, cambios sin guardar…).
        this.mo = new MutationObserver(this.programar);
        this.mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
        this.programar();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.programar);
        window.removeEventListener('resize', this.programar);
        if (this.mo) this.mo.disconnect();
        cancelAnimationFrame(this.raf);
    },
    watch: {
        $route() { this.programar(); },
    },
    methods: {
        /* Si una barra de abajo queda debajo del botón (en su posición normal),
           el botón sube lo justo para quedar por encima de ella. */
        medir() {
            const el = this.$el;
            if (!el || !el.getBoundingClientRect) return;
            const cs = getComputedStyle(el);
            const base = parseFloat(cs.getPropertyValue('--wa-base')) || 0;
            const size = el.offsetHeight;
            const right = parseFloat(cs.right) || 0;
            const H = window.innerHeight, W = document.documentElement.clientWidth;
            const x1 = W - right - size, x2 = W - right;
            const y1 = H - base - size; // borde de arriba del botón sin subir
            let need = 0;
            document.querySelectorAll(OBSTACULOS).forEach(o => {
                if (o.closest('.whatsapp-chat')) return;
                const r = o.getBoundingClientRect();
                if (!r.width || !r.height || r.bottom <= 0 || r.top >= H) return;
                if (getComputedStyle(o).visibility === 'hidden') return;
                if (r.right <= x1 || r.left >= x2) return;      // no está en la columna del botón
                if (r.bottom <= y1 - AIRE) return;              // queda por encima del botón
                need = Math.max(need, Math.min(H, H - r.top + AIRE) - base);
            });
            this.lift = Math.max(0, Math.round(need));
        },
    },
};
</script>

<style lang="scss" scoped>

/* Más chico y más pegado a la esquina (pedido 19/10). Sube solo (--wa-lift,
   ver medir()) cuando una barra de guardar o el aviso de cookies queda
   debajo, para no tapar sus botones. */
.whatsapp-chat {
    --wa-base: 18px;
    position: fixed;
    bottom: calc(var(--wa-base) + var(--wa-lift, 0px));
    right: 14px;
    width: 40px;
    height: 40px;
    z-index: 5;
    transition: bottom .2s ease;
}

@media (min-width: $md) {
    .whatsapp-chat {
        --wa-base: 24px;
        right: 24px;
        width: 44px;
        height: 44px;
    }
}

img {
    display: block;
    height: 100%;
    width: 100%;
    filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.4));
}

@media (prefers-reduced-motion: reduce) {
    .whatsapp-chat { transition: none; }
}

</style>
